module.exports = __webpack_public_path__ + "static/media/19.bb632ce5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/19.svg
// module id = 2810
// module chunks = 3